import { useState, useCallback } from 'react';
import { Popover } from '@radix-ui/themes';
import { NotificationBell } from './NotificationBell';
import { NotificationList } from './NotificationList';

export function NotificationPopover() {
  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger>
        <div className="flex items-center">
          <NotificationBell onClick={() => setOpen((prev) => !prev)} />
        </div>
      </Popover.Trigger>
      <Popover.Content
        side="bottom"
        sideOffset={16}
        align="end"
        style={{
          width: '392px',
          padding: 0,
          // Card chrome from the design: pronounced rounded corners
          // plus a soft two-layer drop shadow so the popover reads as
          // an elevated panel against the page rather than a flat
          // Radix Popover default.
          //
          // Important: rounded-corner clipping lives on the inner
          // wrapper, NOT on Popover.Content itself. `overflow: hidden`
          // on Popover.Content collides with Radix's internal
          // `max-height: var(--radix-popper-available-height)` rule
          // and breaks the inner `overflow-y: auto` scroll area
          // (wheel events get swallowed by the outer clip box).
          borderRadius: 12,
          boxShadow:
            '0 12px 32px -8px rgba(0,0,0,0.18), 0 4px 12px -4px rgba(0,0,0,0.08)',
        }}
      >
        <div style={{ borderRadius: 12, overflow: 'hidden' }}>
          <NotificationList mode="popover" maxItems={5} onClose={handleClose} />
        </div>
      </Popover.Content>
    </Popover.Root>
  );
}

export default NotificationPopover;
